<template>
	<div class="inbox">
		<header class="masthead">
			<div
				class="email flex"
				title="Click to Copy to clipboard"
				v-clipboard="() => emailAddress"
				v-clipboard:success="clipboardSuccessHandler"
			>
				{{ emailAddress }}
				<svg
					viewBox="0 0 24 24"
					fill="none"
					stroke="var(--dark-blue)"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
					<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
				</svg>
			</div>
		</header>
		<div class="header flex flex-space-between">
			<h2>Inbox: {{ emailCount }}</h2>
			<div v-show="mode=='detail'" @click="mode='list'" class="back-btn flex">
				<svg
					viewBox="0 0 24 24"
					fill="none"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<line x1="19" y1="12" x2="5" y2="12" />
					<polyline points="12 19 5 12 12 5" />
				</svg>
				Go back
			</div>
		</div>
		<div class="loading" v-if="loading">
			<svg viewBox="0 0 100 100">
				<defs>
					<linearGradient id="Gradient" x1="50%" y1="0%" x2="50%" y2="100%">
						<stop offset="0%" stop-color="#00F2FE">
							<animate
								attributeName="stop-color"
								values="#00F2FE; #4FACFE; #00F2FE"
								dur="2s"
								repeatCount="indefinite"
							/>
						</stop>

						<stop offset="100%" stop-color="#4FACFE">
							<animate
								attributeName="stop-color"
								values="#4FACFE; #00F2FE; #4FACFE"
								dur="2s"
								repeatCount="indefinite"
							/>
						</stop>
					</linearGradient>
				</defs>
				<circle class="circle" cx="50" cy="50" r="30" fill="none" />
			</svg>
		</div>
		<div class="email-holder" v-else>
			<div class="empty-inbox" v-if="!emails.length">
				<svg
					viewBox="0 0 24 24"
					fill="none"
					stroke="#f5817a"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					class="new-mailbox"
				>
					<polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
					<path
						d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
					/>
				</svg>
			</div>
			<div class="email-list" v-if="mode=='list'">
				<div
					v-for="(email, index) of sortedEmails"
					:key="index"
					class="email-row flex flex-sm"
					:class="{isRead: email.isRead}"
					@click="getEmail(email.emailId); email.isRead = true"
				>
					<div class="sender">
						<div class="name">{{email.sender.name}}</div>
						<div class="address">{{email.sender.address}}</div>
					</div>
					<div class="details" :title="email.subject">
						<div class="subject">{{email.subject}}</div>
						<div class="text">{{email.text}}</div>
					</div>
					<div class="time flex">
						<span>{{email.timestamp | fromNow }}</span>
						<span class="read"></span>
					</div>
				</div>
				<!-- email-row -->
			</div>
			<div v-if="mode == 'detail'" class="email-details">
				<div class="head flex flex-space-between">
					<div class="head-details">
						<div class="from">
							<span>From:</span>
							{{ email.from.text}}
						</div>
						<div class="subject">
							<span>Subject:</span>
							{{ email.subject }}
						</div>
					</div>
					<div class="head-time">{{email.timestamp | fromNow }}</div>
				</div>
				<div class="body" v-html="(!email.html) ? email.textAsHtml : email.html"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Inbox",
	data() {
		return {
			emails: [],
			email: {},
			loading: false,
			mode: "list"
		};
	},
	created() {
		this.getEmails();

		this.$bus.$on("refresh-mailbox", () => {
			this.emails = [];
			this.mode = "list";
			this.getEmails();
		});
	},
	computed: {
		emailAddress() {
			return `${this.$bus.email.mailbox}@${this.$bus.domain}`;
		},
		emailCount() {
			return this.emails.length ? this.emails.length : "Empty";
		},
		mailbox() {
			return this.$bus.email.mailbox.toLowerCase();
		},
		sortedEmails() {
			let sortable = Object.values(this.emails);

			sortable.sort((a, b) => {
				return b.timestamp - a.timestamp;
			});
			return sortable;
		}
	},
	sockets: {
		connect() {
			console.log("Connected");
		},
		disconnect() {
			console.log("Disconnect");
		},
		emailCount(data) {
			console.log("Got message count update", data);
			this.getEmails();
		}
	},
	methods: {
		getEmails() {
			this.loading = true;

			this.Request.get(`/mailbox/${this.mailbox}/email`)
				.then(({ data }) => {
					console.log(data);
					this.emails = data;
					this.loading = false;
				})
				.catch(error => {
					if (error.response.status === 404) {
						this.loading = false;
					} else {
						this.$bus.error(error);
					}
				});
		},
		getEmail(emailId) {
			this.loading = true;
			this.Request.get(`/mailbox/${this.mailbox}/email/${emailId}`)
				.then(({ data }) => {
					this.mode = "detail";
					this.email = data;
					this.loading = false;
					this.markAsRead(emailId);
				})
				.catch(error => this.$bus.error(error));
		},
		markAsRead(emailId) {
			this.Request.patch(`/mailbox/${this.mailbox}/email/${emailId}`, {
				isRead: true
			})
				.then(({ data }) => console.log(data))
				.catch(error => this.$bus.error(error));
		},
		checkEmailCount() {
			this.Request.get("/emailCount").then(response => {
				console.log(response);
			});
		},
		clipboardSuccessHandler() {
			this.$bus.$emit("notify", { message: "Email was copied" });
		}
	}
};
</script>

<style lang="scss">
$font-color: #2c3e50;
.inbox {
	flex: 1;
	display: flex;
	flex-direction: column;

	.masthead {
		flex: 0 1 auto;
		.email {
			cursor: pointer;
			svg {
				width: 24px;
				margin-left: 10px;
				stroke: #fff;
				opacity: 0.6;
			}
		}
	}

	.header {
		flex: 0 1 auto;
		padding: 0 20px;
		border-bottom: 1px solid var(--border);
		h2 {
			margin: 17.5px 0;
		}
		.back-btn {
			cursor: pointer;
			text-transform: uppercase;
			font-size: 0.9rem;
			color: #26bbea;
			svg {
				width: 20px;
				stroke: #26bbea;
				margin-right: 10px;
			}
		}
	}

	.email-holder {
		flex: 1;
	}

	.email-row {
		justify-content: space-between;
		padding: 20px;
		cursor: pointer;
		flex-wrap: wrap;

		&:not(:first-of-type) {
			border-top: 1px solid var(--border);
		}

		.sender {
			flex: 0 1 30%;
			margin-right: 20px;
		}
		.details {
			flex: 1;
		}
		.time {
			flex: 0 1 auto;
			font-size: 0.8rem;
			align-self: flex-start;

			.read {
				width: 10px;
				height: 10px;
				background: var(--dark-blue);
				display: inline-block;
				border-radius: 5px;
				margin-left: 5px;
			}
		}
		.name,
		.subject {
			font-weight: 600;
			white-space: nowrap;
			text-overflow: ellipsis;
			max-width: 500px;
			overflow: hidden;
		}
		.address,
		.text {
			font-size: 0.85rem;
		}

		.name {
			max-width: 300px;
		}
		&.isRead {
			.name,
			.subject {
				font-weight: 400;
			}

			.time {
				.read {
					background: #eee;
				}
			}
		}
	}

	.email-details {
		.head {
			padding: 10px 20px;
			border-bottom: 1px solid var(--border);
			.head-details {
				div {
					line-height: 1.5;
					span {
						font-weight: 600;
						font-size: 0.9rem;
					}
				}
			}
			.head-time {
				font-size: 0.85rem;
			}
		}
		.body {
			padding: 20px;

			img {
				max-width: 100%;
				height: auto !important;
			}
		}
	}
}
.empty-inbox {
	text-align: center;
	padding-top: 80px;
	svg {
		width: 50px;
		opacity: 0.4;
		stroke: lighten($font-color, 50);
	}
}
.loading {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding-top: 80px;
	svg {
		width: 80px;
	}
}
.circle {
	animation: 2s loader ease infinite alternate, 1s loader2 linear infinite;
	stroke: url(#Gradient);
	stroke-linecap: round;
	stroke-width: 8;
	stroke-dasharray: 94.0955352783 94.0955352783;
	stroke-dashoffset: 0;
}

@keyframes loader {
	0% {
		stroke-dasharray: 84.0955352783 104.0955352783;
	}
	100% {
		stroke-dasharray: 178.19107055664062 10;
	}
}
@keyframes loader2 {
	0% {
		stroke-dashoffset: 0;
	}
	100% {
		stroke-dashoffset: -188.19107055664062;
	}
}

@media screen and (max-width: 767px) {
	.inbox {
		.email-row {
			text-align: left;

			.sender,
			.details {
				margin: 0 0 10px;
			}
		}
	}
}
</style>